const t = "_innerWrapper_znpxq_1", e = "_eyebrow_znpxq_18", r = "_title_znpxq_19", n = "_text_znpxq_22", p = "_link_znpxq_23", _ = "_textWrapper_znpxq_42", a = "_readabilityBackdrop_znpxq_68", i = {
  innerWrapper: t,
  eyebrow: e,
  title: r,
  text: n,
  link: p,
  textWrapper: _,
  readabilityBackdrop: a
};
export {
  i as default,
  e as eyebrow,
  t as innerWrapper,
  p as link,
  a as readabilityBackdrop,
  n as text,
  _ as textWrapper,
  r as title
};
